import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { user, loading, isAdmin, isSuperAdmin } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh', background: '#0A1628' }}>
        <output className="spinner-border text-success">
          <span className="visually-hidden">Chargement...</span>
        </output>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // isAdmin couvre admin ET superadmin : ce dernier ne doit jamais avoir
  // moins d'acces qu'un administrateur.
  if (superAdminOnly && !isSuperAdmin) {
    return <Navigate to="/" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}
